/* eslint-disable indent */
import React, { useState } from 'react'
import { Card, Col, Row, Button, Form, ButtonGroup } from 'react-bootstrap'
import { skillArr, translations } from '../services/arrays'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { initializeUser } from '../reducers/userReducer'
import axios from 'axios'
import TeamPlayerSorter from './TeamSorter'
import { useNavigate } from 'react-router-dom'

const TeamTrainingPlan = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [players, setPlayers] = useState([])
  const [trainingWeeks, setTrainingWeeks] = useState([])
  const [newPlayers, setNewPlayers] = useState([])
  const user = useSelector(state => state.user)

  // TIETOTURVA: Tarkista Staff-oikeudet
  const hasStaffAccess = user && user.staff && user.staff.length > 0

  // TIETOTURVA: Ohjaa pois jos ei Staff-oikeuksia
  useEffect(() => {
    // Odotetaan että user.staff on määritelty (ei undefined) ennen tarkistusta
    // Jos user on olemassa JA staff on määritelty JA ei ole Staff-oikeuksia, ohjaa pois
    if (user && user.staff !== undefined && !hasStaffAccess) {
      navigate('/')
    }
  }, [user, hasStaffAccess, navigate])

  useEffect(() => {
    const loadData = async () => {
      const userData = await dispatch(initializeUser())
      if (!userData) return

      // Tarkista Staff-oikeudet
      const userHasStaffAccess =
        userData && userData.staff && userData.staff.length > 0
      console.log('TeamTrainingPlan - userHasStaffAccess:', userHasStaffAccess)
      if (!userHasStaffAccess) {
        console.log('TeamTrainingPlan - Ei Staff-oikeuksia, lopetetaan')
        return
      }

      const token = userData.oauth_token || userData.id
      const playersdata = await axios.get('/api/players/' + token)
      console.log(players.data)
      setPlayers(playersdata.data)
      console.log('dispatsataan pelaajat')
      const news = await axios.get('/users/trainingplan/' + token)
      setNewPlayers(news.data.trainingPlan.players)
      setTrainingWeeks(news.data.trainingPlan.trainingPlan)
      console.log(news.data)
    }
    loadData()
  }, [])
  const language = [0]

  const [newPlayer, setNewPlayer] = useState({
    firstName: '',
    age: '',
    playerSkills: {},
  })

  const togglePlayerVisibility = playerId => {
    setPlayers(players => {
      const updatedPlayers = players.map(player =>
        player.playerId === playerId
          ? { ...player, hidden: !player.hidden }
          : player
      )
      return updatedPlayers.sort((a, b) => {
        if (a.hidden === b.hidden) return 0
        return a.hidden ? 1 : -1
      })
    })

    setNewPlayers(newPlayers => {
      const updatedPlayers = newPlayers.map(player =>
        player.playerId === playerId
          ? { ...player, hidden: !player.hidden }
          : player
      )
      return updatedPlayers.sort((a, b) => {
        if (a.hidden === b.hidden) return 0
        return a.hidden ? 1 : -1
      })
    })
  }

  const handleNewPlayerChange = (field, value) => {
    setNewPlayer(prev => ({
      ...prev,
      [field]: value,
    }))
  }

  const handleNewPlayerSkillChange = (skill, value) => {
    console.log({ [skill]: value })
    console.log(value)
    setNewPlayer(prev => ({
      ...prev,
      playerSkills: { ...prev.playerSkills, [skill]: Number(value) },
    }))
    console.log(newPlayer)
  }

  const addNewPlayer = () => {
    console.log(newPlayer.age.length)
    setNewPlayers(prev => [
      ...prev,
      {
        playerId: Date.now(),
        ...newPlayer,
        age: Number(newPlayer.age.slice(0, 2)),
        ageDays: Number(newPlayer.age.slice(3, newPlayer.age.length)),
        hidden: false,
      },
    ])
    setNewPlayer({
      firstName: '',
      age: '',
      ageDays: '',
      playerSkills: { ...newPlayer.playerSkills },
    })
  }

  const deleteNewPlayer = playerId => {
    setNewPlayers(newPlayers.filter(p => p.playerId !== playerId))
  }

  const handleAddskillWeeks = () => {
    setTrainingWeeks([...trainingWeeks, { skill: '', weeks: '' }])
  }

  // Funktio, joka käsittelee tavoitteen muutoksen
  const handleSkillWeekChange = (index, field, value) => {
    const newtrainingWeeks = [...trainingWeeks]
    newtrainingWeeks[index][field] = value
    setTrainingWeeks(newtrainingWeeks)
  }

  const handleRemoveskillWeeks = index => {
    const updatedSkills = trainingWeeks.filter((_, i) => i !== index)
    setTrainingWeeks(updatedSkills) // Päivitä tilan `trainingWeeks`
  }

  /*const handleDeleteTrainingPlan = async () => {
    try {
      await axios.get('/api/players/deletemytrainingplan/' + player.playerId)
      setTrainingPlan()
      addMessage('Harjoittelusuunnitelma poistettu onnistuneesti!')
    } catch (error) {
      addMessage('Harjoittelusuunnitelman poistaminen epäonnistui.')
    }
  }*/

  // Funktio lähettää taidot backendille

  const mapUpdatedPlayerSkills = (players, newSkills) => {
    // Luo Map, jossa avaimena playerId ja arvona pelaajan uudet taidot
    const skillsMap = new Map(newSkills.map(skill => [skill.playerId, skill]))

    // Mapataan pelaajat uusin tiedoin
    return players.map(player => {
      const skillData = skillsMap.get(player.playerId)
      if (skillData) {
        return {
          ...player,
          newPlayerSkills: skillData.currentSkills,
          newAge: skillData.age[0],
          newAgeDays: skillData.age[1],
        }
      }
      return player // Palautetaan pelaaja ennallaan, jos taitoja ei löytynyt
    })
  }

  const submitTrainingPlan = async (trainingPlan, userId) => {
    try {
      const response = await axios.post(
        `/users/trainingplan/${userId}`,
        trainingPlan
      )
      if (response.status === 200) {
        alert('Harjoitusohjelma tallennettu onnistuneesti')
      }
    } catch (error) {
      console.error('Virhe harjoitusohjelman tallennuksessa:', error)
      alert('Virhe harjoitusohjelman tallennuksessa')
    }
  }

  const handleSubmitTrainingPlan = async () => {
    try {
      const playersData = players.concat(newPlayers).map(player => ({
        currentSkills: player.playerSkills,
        coach: 5,
        assistants: 10,
        intensity: 100,
        stamina: 10,
        trainingWeeks: trainingWeeks,
        minutes: 90,
        efficiency: 1,
        age: [player.age, player.ageDays],
        date: new Date(),
        firstName: player.firstName,
        lastName: player.lastName,
        playerId: player.playerId,
      }))
      console.log(playersData)

      const response = await axios.post('/api/players/bulk/1234', playersData)
      const newSkills = response.data.results
      const updatedPlayers = mapUpdatedPlayerSkills(players, newSkills)
      setPlayers(updatedPlayers)
      const updatedNewPlayers = mapUpdatedPlayerSkills(newPlayers, newSkills)
      setNewPlayers(updatedNewPlayers)
      await submitTrainingPlan(
        { trainingPlan: trainingWeeks, players: newPlayers, date: new Date() },
        user.oauth_token
      )

      console.log(updatedPlayers)
    } catch (error) {
      console.log(error)
      //addMessage('Harjoittelusuunnitelman lähettäminen epäonnistui.')
    }
  }

  // TIETOTURVA: Näytä viesti jos ei Staff-oikeuksia
  // Mutta vain jos user.staff on määritelty (ei undefined)
  if (user && user.staff !== undefined && !hasStaffAccess) {
    return (
      <Card bg="dark" text="light" className="mt-3">
        <Card.Body className="text-center">
          <h4>Ei käyttöoikeutta</h4>
          <p>Tämä sivu on tarkoitettu vain maajoukkueen Staff-jäsenille.</p>
          <Button variant="primary" onClick={() => navigate('/')}>
            Palaa etusivulle
          </Button>
        </Card.Body>
      </Card>
    )
  }

  return (
    <>
      <TeamPlayerSorter players={players} setPlayers={setPlayers} />
      <Row>
        <Col md={9}>
          <Row>
            {players.concat(newPlayers).map(player => (
              <Col key={player.id} md={4} className="mb-1">
                <Card
                  style={{
                    backgroundColor: '#2C2F33',
                    color: '#FFFFFF',
                    borderColor: '#1E2124',
                  }}
                >
                  {!player.hidden ? (
                    <>
                      <Card.Body>
                        <Card.Text style={{ fontSize: '0.700rem' }}>
                          <strong>
                            {player.firstName} {player.lastName}
                          </strong>
                        </Card.Text>
                        <Card.Text style={{ fontSize: '0.700rem' }}>
                          Ikä: {player.age}.{player.ageDays}{' '}
                          {player.newAge
                            ? 'Uusi ikä: ' +
                              player.newAge +
                              '.' +
                              player.newAgeDays
                            : ''}
                        </Card.Text>
                        <Card.Text>
                          {skillArr.map(skill => (
                            <Row key={skill} className="mb-1">
                              <Col sm="4">
                                <span
                                  style={{
                                    color: '#FFFFFF',
                                    fontSize: '0.650rem',
                                  }}
                                >
                                  {translations[skill][language]
                                    ? translations[skill][language]
                                    : skill.replace('Skill', '')}
                                  :
                                </span>
                              </Col>
                              <Col sm="4" className="d-flex align-items-center">
                                <span
                                  style={{
                                    backgroundColor: '#23272A',
                                    color: '#FFFFFF',
                                    width: '80px',
                                    padding: '5px',
                                    textAlign: 'center',
                                    borderRadius: '3px',
                                    fontSize: '0.700rem',
                                  }}
                                >
                                  {player.playerSkills[skill]
                                    .toFixed(3)
                                    .replace('.', ',')}
                                </span>
                              </Col>
                              {player.newPlayerSkills ? (
                                <Col
                                  sm="4"
                                  className="d-flex align-items-center"
                                >
                                  <span
                                    style={{
                                      backgroundColor: '#23272A',
                                      color: '#FFFFFF',
                                      width: '80px',
                                      padding: '5px',
                                      textAlign: 'center',
                                      borderRadius: '4px',
                                      fontSize: '0.700rem',
                                    }}
                                  >
                                    {player.newPlayerSkills[skill]
                                      .toFixed(3)
                                      .replace('.', ',')}
                                  </span>
                                </Col>
                              ) : (
                                ''
                              )}
                            </Row>
                          ))}
                        </Card.Text>
                      </Card.Body>
                      <Card.Footer>
                        <ButtonGroup>
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() =>
                              togglePlayerVisibility(player.playerId)
                            }
                          >
                            Piilota
                          </Button>
                          {newPlayers
                            .map(p => p.playerId)
                            .includes(player.playerId) ? (
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() => deleteNewPlayer(player.playerId)}
                            >
                              Poista
                            </Button>
                          ) : (
                            <></>
                          )}
                        </ButtonGroup>
                      </Card.Footer>
                    </>
                  ) : (
                    <>
                      <Card.Body>
                        <Card.Text>
                          {player.firstName} {player.lastName}
                        </Card.Text>
                      </Card.Body>
                      <Card.Footer>
                        <Button
                          variant="success"
                          size="sm"
                          onClick={() =>
                            togglePlayerVisibility(player.playerId)
                          }
                        >
                          Näytä
                        </Button>
                      </Card.Footer>
                    </>
                  )}
                </Card>
              </Col>
            ))}
          </Row>
        </Col>

        <Col md={3}>
          <Row>
            <Card
              style={{
                backgroundColor: '#2C2F33',
                color: '#FFFFFF',
                borderColor: '#1E2124',
              }}
            >
              <Card.Header
                style={{ backgroundColor: '#23272A', color: '#FFFFFF' }}
              >
                Harjoitusviikkojen lisäys
              </Card.Header>
              <Card.Body>
                {trainingWeeks.map((skillWeeks, index) => (
                  <Row key={index} className="mb-2">
                    <Col xs={5}>
                      <Form.Control
                        as="select"
                        value={skillWeeks.skill}
                        onChange={e =>
                          handleSkillWeekChange(index, 'skill', e.target.value)
                        }
                        style={{
                          backgroundColor: '#23272A',
                          color: '#FFFFFF',
                          fontSize: '12px',
                          padding: '3px',
                        }}
                      >
                        <option value="">Valitse taito</option>
                        {skillArr.map(skill => (
                          <option key={skill} value={skill}>
                            {translations[skill][language]}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>
                    <Col xs={4}>
                      <Form.Control
                        type="number"
                        placeholder="Viikot"
                        value={skillWeeks.weeks}
                        onChange={e =>
                          handleSkillWeekChange(index, 'weeks', e.target.value)
                        }
                        style={{
                          backgroundColor: '#23272A',
                          color: '#FFFFFF',
                          width: '60px',
                          fontSize: '12px',
                          padding: '3px',
                        }}
                      />
                    </Col>
                    <Col xs={3}>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleRemoveskillWeeks(index)}
                      >
                        Poista
                      </Button>
                    </Col>
                  </Row>
                ))}
                <div className="d-flex flex-column">
                  <Button
                    onClick={handleAddskillWeeks}
                    className="mt-2"
                    size="sm"
                  >
                    Lisää uusi harjoitusjakso
                  </Button>
                </div>
                <Row>
                  <div className="d-flex flex-column">
                    <Button
                      onClick={handleSubmitTrainingPlan}
                      className="mt-2"
                      size="sm"
                    >
                      Lähetä harjoitussuunnitelma
                    </Button>
                  </div>
                </Row>
              </Card.Body>
            </Card>
          </Row>

          <Row className="mt-3">
            <Card
              className="flex-fill"
              style={{
                backgroundColor: '#2C2F33',
                color: '#FFFFFF',
                borderColor: '#1E2124',
              }}
            >
              <Card.Header style={{ backgroundColor: '#23272A' }}>
                Luo uusi pelaaja
              </Card.Header>
              <Card.Body>
                <Form>
                  <Form.Group>
                    <Row>
                      <Col xs={3}>
                        <Form.Label>Nimi</Form.Label>
                      </Col>
                      <Col xs={9}>
                        <Form.Control
                          type="text"
                          value={newPlayer.firstName}
                          onChange={e =>
                            handleNewPlayerChange('firstName', e.target.value)
                          }
                          style={{
                            backgroundColor: '#23272A',
                            color: '#FFFFFF',
                            fontSize: '12px',
                            padding: '3px',
                          }}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group>
                    <Row>
                      <Col xs={7}>
                        <Form.Label>Ikä (esim. 17.3)</Form.Label>
                      </Col>
                      <Col xs={5}>
                        <Form.Control
                          type="string"
                          value={newPlayer.age}
                          onChange={e =>
                            handleNewPlayerChange('age', e.target.value)
                          }
                          style={{
                            backgroundColor: '#23272A',
                            color: '#FFFFFF',
                            fontSize: '12px',
                            padding: '3px',
                          }}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  {skillArr.map((skill, index) => (
                    <Form.Group key={index}>
                      <Row>
                        <Col xs={7}>
                          <Form.Label>
                            {translations[skill][language]}
                          </Form.Label>
                        </Col>
                        <Col xs={5}>
                          <Form.Control
                            type="number"
                            value={newPlayer.playerSkills[skill]}
                            onChange={
                              e =>
                                handleNewPlayerSkillChange(
                                  skill,
                                  e.target.value
                                )
                              //console.log(skill + ' ' + e.target.value)
                            }
                            style={{
                              backgroundColor: '#23272A',
                              color: '#FFFFFF',
                              fontSize: '12px',
                              padding: '3px',
                            }}
                          />
                        </Col>
                      </Row>
                    </Form.Group>
                  ))}
                </Form>
                <Button className="mt-3" onClick={addNewPlayer}>
                  Lisää pelaaja
                </Button>
              </Card.Body>
            </Card>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default TeamTrainingPlan
